export const GET_VIBE_WHEEL_HISTORY = "GET_VIBE_WHEEL_HISTORY";
export const GET_VIBE_WHEEL_STATS = "GET_VIBE_WHEEL_STATS";
export const GET_VIBE_WHEEL = "GET_VIBE_WHEEL";
export const RESET_VIBE_WHEEL_COIN = "RESET_VIBE_WHEEL_COIN";
export const GET_VIBE_WHEEL_ADMIN_COIN_COUNT = "GET_VIBE_WHEEL_ADMIN_COIN_COUNT";
export const RESET_VIBE_WHEEL_ADMIN_COIN = "RESET_VIBE_WHEEL_ADMIN_COIN";